import React from 'react'
import {useTranslation} from 'react-i18next'
import {KTSVG, toAbsoluteUrl} from 'app/utils/helpers'
import {Languages} from 'app/utils/common/constants'
import {useAppSelector} from 'setup/redux/Hooks'
import {selectLanguage} from 'app/modules/auth'
import './style.scss'

interface ServiceFirstRunProps {
  onLoadB8akServices?: () => void
  onAddServiceCategory?: () => void
}

const BENEFIT_KEYS = [
  'SERVICE_MANAGEMENT_PAGE.FIRST_RUN.BENEFIT_MARKETPLACE_ORDERS',
  'SERVICE_MANAGEMENT_PAGE.FIRST_RUN.BENEFIT_PREFILLED_DATA',
  'SERVICE_MANAGEMENT_PAGE.FIRST_RUN.BENEFIT_GO_LIVE',
]

const ServiceFirstRun: React.FC<ServiceFirstRunProps> = ({
  onLoadB8akServices,
  onAddServiceCategory,
}) => {
  const {t} = useTranslation()
  const language = useAppSelector(selectLanguage)
  const rtl = language === Languages.ar

  return (
    <div className='service-first-run'>
      <div className='service-first-run__card'>
        <img
          className='service-first-run__logo'
          src={toAbsoluteUrl('/assets/images/common/b8ak logo.png')}
          alt={t('SERVICE_MANAGEMENT_PAGE.FIRST_RUN.LOGO_ALT')}
        />

        <h2 className='service-first-run__heading'>
          {t('SERVICE_MANAGEMENT_PAGE.FIRST_RUN.HEADING')}
        </h2>

        <p className='service-first-run__subheading'>
          {t('SERVICE_MANAGEMENT_PAGE.FIRST_RUN.SUBHEADING')}
        </p>

        <button
          type='button'
          className='service-first-run__btn-primary'
          onClick={onLoadB8akServices}
        >
          <KTSVG defaultColor={true} path='/assets/images/icons/bolt.svg' />
          {t('SERVICE_MANAGEMENT_PAGE.FIRST_RUN.LOAD_B8AK_SERVICES')}
        </button>

        <ul className='service-first-run__benefits'>
          {BENEFIT_KEYS.map((key) => (
            <li key={key} className='service-first-run__benefit'>
              <KTSVG
                defaultColor={true}
                className='service-first-run__check'
                path='/assets/images/icons/check-circle-green.svg'
              />
              <span>{t(key)}</span>
            </li>
          ))}
        </ul>

        <p className='service-first-run__footer'>
          {t('SERVICE_MANAGEMENT_PAGE.FIRST_RUN.PREFER_OWN')}{' '}
          <button type='button' className='service-first-run__link' onClick={onAddServiceCategory}>
            {t('SERVICE_MANAGEMENT_PAGE.FIRST_RUN.ADD_A_SERVICE_CATEGORY')}
            <span className='service-first-run__arrow' aria-hidden='true'>
              {rtl ? '←' : '→'}
            </span>
          </button>
        </p>
      </div>
    </div>
  )
}

export default ServiceFirstRun
